module.exports = __webpack_public_path__ + "img/localizacion.680ee52d.png";